module.exports = __webpack_public_path__ + "media/images/athletes/3535-0c06b855764b1f4d6898a67bf232bb32.png";